import { IProgrammeSearchApplicationState } from '@studyportals/fawkes/programmes-search-seo';
import store from '@/study-search/store';

export class SeoApplicationState implements IProgrammeSearchApplicationState {
	private static instance: IProgrammeSearchApplicationState;

	// eslint-disable-next-line @typescript-eslint/no-empty-function
	private constructor() {}

	public static getInstance(): IProgrammeSearchApplicationState {
		if (!SeoApplicationState.instance) {
			SeoApplicationState.instance = new SeoApplicationState();
		}
		return SeoApplicationState.instance;
	}

	public getNumberOfResults(): number {
		return store.getters.getTotalSearchResults();
	}

	public getPageNumber(): number {
		return store.getters.getPageNumber();
	}
}
